import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { AddExpenseDialogComponent } from './add-expense-dialog.component'

@Injectable({
  providedIn: 'root',
})
export class AddExpenseDialogService {
  constructor(private dialog: MatDialog) {}

  open() {
    const defaultConfig: MatDialogConfig = {
      width: '950px',
      panelClass: ['variable-modal'],
      data: {},
    }

    return this.dialog.open(AddExpenseDialogComponent, defaultConfig)
  }
}
